import { Chip } from "@mui/material";
import React, {useMemo,memo} from "react";
import GaugeChart from "react-gauge-chart";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: '50px',       
};

const RadonKPI = memo(({ avgRadon, minRadon, maxRadon }) => {


  const percentage = useMemo(()=>{
  
    if (avgRadon >300  && avgRadon <=1000) return 0.2;
    if (avgRadon > 100 && avgRadon <= 300) return 0.5;
    if (avgRadon >= 0 && avgRadon <= 100) return 0.8;
    
    return 0.2; 
  
  },[avgRadon])

  return (
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        arcsLength={[0.1,0.1,0.1]}
        colors={["red","yellow","#82f61d"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={percentage}
        hideText={true}
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgRadon} Bq/m3</span>
      <p className="card-value">Radon</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max"  sx={chipStyle} />
          <p className="m-1 p-0">{maxRadon}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min"  sx={chipStyle} />
          <p className="m-1 p-0">{minRadon}</p>
        </div>
      </div>
    </>
  );
});

export default RadonKPI;
